import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { printoutsRoutes } from './routes'
import { printoutsPath } from './index'
import { toRelativeRoute, wrapRoutesWithRouter } from '../shared/utils/routerPaths'

const wrappedPrintoutsRoutes = wrapRoutesWithRouter(printoutsRoutes)
import { PrintoutLayout } from './PrintoutLayout'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { DriversProvider } from '../shared/context/drivers/DriversContext'
import { TaskProvider } from '../shared/context/TaskContext'
import { RaportFormProvider } from './context/RaportFormContext'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'

const PrintoutModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
        <TaskProvider>
            <DriversProvider>
                  <AppLayoutDahboardWithNav>
                    <ErrorBoundary
                      fallback={(e) => (
                        <ErrorFallback error={e.error} onRetry={e.reset} />
                      )}
                    >
                      <PermissionGuard companyId={companyId} {...moduleAccess.printouts}>
                      <RaportFormProvider>
                        <Routes>
                          {wrappedPrintoutsRoutes.map((route) => (
                        <Route
                                key={route.path}
                                path={`${toRelativeRoute(route.path, printoutsPath)}/*`}
                                element={
                                  <PrintoutLayout
                                    companyId={companyId!}
                                    heightScreen={route.heightScreen}
                                    fullScreen={route.fullScreen}
                                    viewControlBar={route.viewControlBar}
                                  >
                                    <route.Component />
                                  </PrintoutLayout>
                                }
                              />
                      ))}

                          <Route
                            path="*"
                            element={
                              <PrintoutLayout companyId={companyId!}>
                                <div>Select</div>
                              </PrintoutLayout>
                            }
                          />
                        </Routes>
                      </RaportFormProvider>
                      </PermissionGuard>
                    </ErrorBoundary>
                  </AppLayoutDahboardWithNav>
            </DriversProvider>
        </TaskProvider>
    </ErrorBoundary>
  )
}

export const PrintoutModule = PrintoutModuleImpl
